/**
 * Zurückziehen ins Hauptfenster (User 27.10.2026: „kann man das Fenster dann
 * wieder reinziehen?“). Ein ausgelagertes Fenster steht nicht mehr im Dock, und
 * „Zurück in KMVS“ macht aus dem Browserfenster ein eigenes KMVS. Zurück kommt
 * es, indem man seine Kopfleiste auf das KMVS-Hauptfenster zieht — samt Inhalt,
 * an die Stelle, an der man loslässt.
 *
 * Gezogen wird per HTML-Drag-and-drop; das geht zwischen zwei Fenstern
 * desselben Browsers. Welches Fenster unterwegs ist, steht hier statt in den
 * Zieh-Daten: Beide Fenster laufen im selben Skript, und die Daten lassen sich
 * erst beim Loslassen lesen.
 */

/** Eigener Zieh-Datentyp — Ablageflächen für Dateien und Mails reagieren nicht darauf. */
export const ZIEH_ART = "application/x-kmvs-fenster";

/** Wo auf der Titelleiste der Zeiger nach dem Ablegen sitzt (vom linken oberen Eck). */
const GRIFF = { x: 80, y: 18 };

let unterwegs: string | null = null;
const abos = new Set<() => void>();

const melden = () => abos.forEach((f) => f());

/** Beim `dragstart` an der Kopfleiste im Browserfenster. */
export function beginneZurueckziehen(fensterId: string, daten: DataTransfer | null) {
  if (daten) {
    daten.setData(ZIEH_ART, fensterId);
    daten.effectAllowed = "move";
  }
  unterwegs = fensterId;
  // Erst nach dem `dragstart` melden: Ändert sich das DOM noch währenddessen,
  // bricht Chromium das Ziehen ab.
  window.setTimeout(melden, 0);
}

/** Abgelegt oder abgebrochen. */
export function beendeZurueckziehen() {
  if (unterwegs === null) return;
  unterwegs = null;
  melden();
}

/** Das Fenster, dessen Kopfleiste gerade gezogen wird — sonst `null`. */
export function zurueckgezogenesFenster(): string | null {
  return unterwegs;
}

export function abonniereZurueckziehen(f: () => void): () => void {
  abos.add(f);
  return () => {
    abos.delete(f);
  };
}

/**
 * Wo das Fenster im Fenster-Layer landet: mit der Titelleiste unter dem
 * Zeiger, aber ganz auf der Fläche.
 */
export function ablagePosition(
  zeiger: { x: number; y: number },
  layer: { left: number; top: number; width: number; height: number },
  groesse: { width: number; height: number },
): { x: number; y: number } {
  const x = zeiger.x - layer.left - GRIFF.x;
  const y = zeiger.y - layer.top - GRIFF.y;
  return {
    x: Math.round(Math.max(0, Math.min(x, layer.width - groesse.width))),
    y: Math.round(Math.max(0, Math.min(y, layer.height - groesse.height))),
  };
}
